import Vue from "vue";
import Router from "vue-router";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(Vuex);
Vue.use(Router);
Vue.use(VueAxios, axios);

export default new Router({
  routes: [
    {
      path: "*",
      meta: {
        public: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/components/login"),
      meta: {
        public: true,
      },
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/components/home"),
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("@/components/dashboard"),
    },
    {
      path: "/reportsPage/stepper",
      name: "stepper",
      component: () => import("@/components/stepper"),
    },
    {
      path: "/commands",
      name: "commands",
      component: () => import("@/components/commands"),
    },
    {
      path: "/vehiclesExceptions",
      name: "vehiclesExceptions",
      component: () => import("@/components/vehiclesExceptions"),
    },
    {
      path: "/accountBalancePage",
      name: "accountBalancePage",
      component: () => import("@/components/accountBalancePage"),
    },
    {
      path: "/reportsPage",
      name: "reportsPage",
      component: () => import("@/components/reportsPage"),
    },
    {
      path: "/accountManager",
      name: "accountManager",
      component: () => import("@/components/accountManager"),
    },
    {
      path: "/operator",
      name: "operator",
      component: () => import("@/components/operator"),
    },
    {
      path: "/mobilePhone",
      name: "mobilePhone",
      component: () => import("@/components/mobilePhone"),
    },
    {
      path: "/traffic",
      name: "traffic",
      component: () => import("@/components/traffic"),
    },
    {
      path: "/traffic/addTravel",
      name: "addTravel",
      component: () => import("@/components/addTravel"),
    },
    {
      path: "/traffic/editTravel",
      name: "editTravel",
      component: () => import("@/components/editTravel"),
    },
    {
      path: "/carriers",
      name: "carriers",
      component: () => import("@/components/carriers"),
    },
    {
      path: "/carriers/addCarrier",
      name: "addCarrier",
      component: () => import("@/components/addCarrier"),
    },
    {
      path: "/carriers/editCarrier",
      name: "editCarrier",
      component: () => import("@/components/editCarrier"),
    },
    {
      path: "/dashboard/alertruckVehiclesInfo",
      name: "alertruckVehiclesInfo",
      component: () => import("@/components/alertruckVehiclesInfo"),
    },
    {
      path: "/dashboard/performance",
      name: "performance",
      component: () => import("@/components/performance"),
    },
    {
      path: "/dashboard/performance/individual",
      name: "individual",
      component: () => import("@/components/individual"),
    },
    {
      path: "/dashboard/inTransitIncidents",
      name: "inTransitIncidents",
      component: () => import("@/components/inTransitIncidents"),
    },
    {
      path: "/dashboard/performance/individual/comparative",
      name: "comparative",
      component: () => import("@/components/comparative"),
    },
    {
      path: "/individualFuel",
      name: "individualFuel",
      component: () => import("@/components/individualFuel"),
    },
    {
      path: "/tracking",
      name: "tracking",
      component: () => import("@/components/tracking"),
    },
    {
      path: "/settingsAT",
      name: "settingsAT",
      component: () => import("@/components/settingsAT"),
    },
    {
      path: "/settingsAT/verifyConfiguration",
      name: "verifyConfiguration",
      component: () => import("@/components/verifyConfiguration"),
    },
    {
      path: "/settingsAT/configurationProgress",
      name: "configurationProgress",
      component: () => import("@/components/configurationProgress"),
    },
    {
      path: "/settingsAT/assignTemplate",
      name: "assignTemplate",
      component: () => import("@/components/assignTemplate"),
    },
  ],
});
